import React, { ReactNode } from 'react';

import styled from 'styled-components/macro';
import cx from 'classnames';

type Props = {
  panelBodyClassName?: string;
  className?: string;
  id?: string;
  children?: ReactNode;
};

export const Panel = (props: Props) => {
  const { className, id, children, panelBodyClassName } = props;

  return (
    <Wrapper className={cx('panel', className)} id={id}>
      <div className={cx('panel-content', panelBodyClassName)}>{children}</div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  border-radius: 2px;
  border: 1px solid #d7d7d7;
  padding: 15px;

  .panel-content {
    position: relative;

    @media (max-width: 767px) {
      padding: 10px;
    }
  }
`;
